import { FC } from "react";
import classNames from "classnames";

import { UpgradePlanButtonProps } from "./types";

import styles from "./UpgradePlanButton.module.css";

const DEFAULT_LABEL = "Upgrade to Advanced Plan";

const UpgradePlanButton: FC<UpgradePlanButtonProps> = ({
  className,
  label = DEFAULT_LABEL,
  onUpgrade,
}) => {
  const handleClick = () => {
    onUpgrade?.();
  };

  return (
    <button
      type="button"
      className={classNames(styles["upgrade-plan-button"], className)}
      onClick={handleClick}
    >
      ✨ <span className={styles["upgrade-plan-button__label"]}>{label}</span>
    </button>
  );
};

export default UpgradePlanButton;
